package com.milta.feature.admin.presentation

sealed interface AdminOcrAnalysisIntent {
    data object Load : AdminOcrAnalysisIntent
}
